export enum PageErrorEnum {
  SHOPPING_BASKET_EMPTY = 'SHOPPING_BASKET_EMPTY',
  SHOPPING_BASKET_CLOSED = 'SHOPPING_BASKET_CLOSED',
  SHOPPING_BASKET_NOT_FOUND = 'SHOPPING_BASKET_NOT_FOUND',
}
